import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getCalculatedFarmFootprintByYear, getCalculatedFarmFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_FARM_CALCULATED_FOOTPRINT } from "consts";

export const useGetFootprintingCalculatedFarmFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_FARM_CALCULATED_FOOTPRINT, farmId, year, isAdmin],
      queryFn: () => (isAdmin ? getCalculatedFarmFootprintByYearAdmin(farmId ?? "", year) : getCalculatedFarmFootprintByYear(farmId ?? "", year)),
      enabled: enabled && !!farmId && !!year && isLoggedIn && !!carbonProgram?.platformFeatures?.footprinting?.enabled,
      queryClient,
      gcTime: 60000,
    })),
  });
};
